import type AjaxService from 'garaje/services/ajax';
import type FlashMessagesService from 'garaje/services/flash-messages';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';

export async function notifyWorkflow(
  ajax: AjaxService,
  flashMessages: FlashMessagesService,
  workflowId: string,
  approved: boolean,
  reason?: string,
): Promise<void> {
  try {
    await ajax.request(`/a/visits/api/v1/workflows/${workflowId}/approvals`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        approved,
        reason: reason || null,
      },
    });
  } catch (error) {
    flashMessages.showAndHideFlash('error', 'Error notifying workflow system', {
      details: parseErrorForDisplay(error),
    });
    throw error;
  }
}
